import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import Transactions from "./pages/Transactions";
import ApiCredentials from "./pages/ApiCredentials";
import Transfer from "./pages/Transfer";
import Invitations from "./pages/Invitations";
import Simulator from "./pages/Simulator";
import Settings from "./pages/Settings";
import UseCases from "./pages/UseCases";
import Corridors from "./pages/Corridors";
import ApiExplorer from "./pages/ApiExplorer";
import CorporateAccount from "./pages/CorporateAccount";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { auth } = useAuth();
  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  const { auth } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={
          auth.isAuthenticated ? <Navigate to="/" replace /> : <Login />
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/use-cases" element={<UseCases />} />
        <Route path="/corridors" element={<Corridors />} />
        <Route path="/api-explorer" element={<ApiExplorer />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/:id" element={<CustomerDetail />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/api-credentials" element={<ApiCredentials />} />
        <Route path="/transfer" element={<Transfer />} />
        <Route path="/invitations" element={<Invitations />} />
        <Route path="/simulator" element={<Simulator />} />
        <Route path="/corporate" element={<CorporateAccount />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
